exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".LoadingInline__loading___1UWRi {\n\theight: 1.5rem;\n    margin-right: 0.5rem;\n    color: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["mainPanelBackgroundColour"] + "!important;\n}\n\n.LoadingInline__loadingSurround___VUNl6 {\n\tdisplay: flex;\n\tmargin: 1rem 0 0 1rem;\n\talign-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"mainPanelBackgroundColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["mainPanelBackgroundColour"] + "",
	"loading": "LoadingInline__loading___1UWRi",
	"loadingSurround": "LoadingInline__loadingSurround___VUNl6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/LoadingInline.icss
// module id = 1303
// module chunks = 0